import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/permission'
import "element-plus/theme-chalk/el-message-box.css";


createApp(App).use(store).use(router).mount('#app')
